(() => {
  if (window.digestiaCommerceInitialized) return;
  window.digestiaCommerceInitialized = true;

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-dg-quantity]').forEach((group) => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const input = group.querySelector('input');
      const buttons = group.querySelectorAll('[data-dg-step]');
      const sync = () => {
        const value = Number(input.value);
        const minimum = Number(input.min || 0);
        const maximum = input.max === '' ? Infinity : Number(input.max);
        buttons.forEach((button) => {
          button.disabled = Number(button.dataset.dgStep) < 0 ? value <= minimum : value >= maximum;
        });
      };
      buttons.forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (Number(button.dataset.dgStep) < 0) input.stepDown();
          else input.stepUp();
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('input', sync);
      sync();
    });

    scope.querySelectorAll('[data-dg-variant-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.querySelector('[data-dg-variant-submit]').hidden = true;
      form.querySelector('select').addEventListener('change', () => {
        const destination = new URL(form.action, window.location.href);
        const current = new URL(window.location.href);
        ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
          if (current.searchParams.has(key)) destination.searchParams.set(key, current.searchParams.get(key));
        });
        destination.searchParams.set('variant', form.querySelector('select').value);
        window.location.assign(destination.href);
      });
    });

    scope.querySelectorAll('[data-dg-cart-form]').forEach((form) => {
      if (form.dataset.ready || typeof form.requestSubmit !== 'function') return;
      form.dataset.ready = 'true';
      const updateArea = form.querySelector('[data-dg-cart-update]');
      const updateButton = updateArea?.querySelector('[name="update"]');
      if (!updateButton) return;
      updateArea.hidden = true;
      let updateTimer;
      form.querySelectorAll('input[name="updates[]"]').forEach((input) => {
        input.addEventListener('change', () => {
          clearTimeout(updateTimer);
          if (!input.checkValidity()) {
            updateArea.hidden = false;
            return;
          }
          updateTimer = setTimeout(() => form.requestSubmit(updateButton), 600);
        });
      });
      form.addEventListener('submit', () => clearTimeout(updateTimer));
    });

    scope.querySelectorAll('[data-dg-gallery-link]').forEach((link) => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', (event) => {
        const target = document.getElementById(link.hash.slice(1));
        const gallery = target?.closest('[data-dg-gallery]');
        if (!gallery) return;
        event.preventDefault();
        gallery.scrollTo({ left: target.offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });

    scope.querySelectorAll('.dg-product__sticky').forEach((sticky) => {
      if (sticky.dataset.ready) return;
      const product = sticky.closest('.dg-product');
      const primaryButton = product?.querySelector('.dg-product__add');
      if (!primaryButton) return;
      sticky.dataset.ready = 'true';
      let scheduled = false;
      const sync = () => {
        scheduled = false;
        if (!product.isConnected) {
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
          return;
        }
        sticky.hidden = primaryButton.getBoundingClientRect().bottom >= 0;
      };
      const schedule = () => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(sync);
      };
      sync();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
    });

    scope.querySelectorAll('[data-dg-collection]').forEach((collection) => {
      const controls = collection.querySelector('[data-dg-category-controls]');
      if (!controls || controls.dataset.ready) return;
      controls.dataset.ready = 'true';
      controls.hidden = false;
      controls.querySelectorAll('[data-dg-category]').forEach((button) => {
        button.addEventListener('click', () => {
          const category = button.dataset.dgCategory;
          let visible = 0;
          controls.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          collection.querySelectorAll('[data-dg-category-item]').forEach((item) => {
            item.hidden = category !== 'all' && item.dataset.dgCategoryItem !== category;
            if (!item.hidden) visible += 1;
          });
          collection.querySelector('[data-dg-category-empty]').hidden = visible > 0;
        });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
